import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'searchKey'
})
export class SearchTextPipe implements PipeTransform {

  transform(items: any[], searchText: string): any[] {
    if(searchText){
      searchText = searchText.toLowerCase();
    }

      if(!items || !searchText){
        return items;
      }
      return items.filter(item => {
        return item.toLowerCase().includes(searchText);
      })
   }

}
